// extracted by mini-css-extract-plugin
module.exports = {"skills":"MySkills_skills__15PCT","heading":"MySkills_heading__azOm1","resume-div":"MySkills_resume-div__10kcR","resume":"MySkills_resume__1m-pP"};